import Image from "next/image";

export interface HeaderProps {
  logoSrc?: string;
  logoAlt?: string;
  /** Optional URL to wrap the logo in a link. */
  logoHref?: string;
}

export default function Header({
  logoSrc = "/coloniallife-logo.svg",
  logoAlt = "Colonial Life",
  logoHref,
}: HeaderProps) {
  const logo = (
    <Image
      src={logoSrc}
      alt={logoAlt}
      width={162}
      height={40}
      loading="eager"
      className=""
    />
  );

  return (
    <header className="bg-white px-6">
      <div className="py-6 max-w-content mx-auto">
        {logoHref ? (
          <a
            href={logoHref}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${logoAlt} (opens in a new tab)`}
          >
            {logo}
          </a>
        ) : (
          logo
        )}
      </div>
    </header>
  );
}
